import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import ErrorOutlineIcon from 'components/material-symbol/icons/ErrorOutline'
import RouterLinkButton from 'components/router-link-button'
import { useStyles } from './styles'

// Shown while the request is not loadable yet (the backend creates it from
// Stripe's webhook). Same hero as the confirmation so the page does not jump.
export const PurchasePending = () => {
  const classes = useStyles()

  return (
    <Box
      className={clsx(classes.narrowPage, classes.confirmPage)}
      data-testid="virtual-coaching-pending"
      role="status"
    >
      <Box className={classes.confirmHero}>
        <Box
          className={clsx(classes.confirmIcon, classes.confirmIconSuccess)}
          aria-hidden="true"
        >
          <CircularProgress size={28} color="inherit" />
        </Box>
        <Typography variant="h1" className={classes.confirmTitle}>
          Confirming Your Payment
        </Typography>
        <Typography className={clsx(classes.muted, classes.confirmSubtitle)}>
          This usually takes a few seconds. Please keep this page open.
        </Typography>
      </Box>
    </Box>
  )
}

// The payment was canceled or Stripe reports it failed. `retryTo` goes back
// to the checkout so the golfer can try another card.
export const PurchaseFailed = ({ retryTo }) => {
  const classes = useStyles()

  return (
    <Box
      className={clsx(classes.narrowPage, classes.confirmPage)}
      data-testid="virtual-coaching-failed"
    >
      <Box className={classes.confirmHero}>
        <Box
          className={clsx(
            classes.confirmIcon,
            classes.confirmIconSuccess,
            classes.confirmIconError,
          )}
          aria-hidden="true"
        >
          <ErrorOutlineIcon />
        </Box>
        <Typography variant="h1" className={classes.confirmTitle}>
          Payment Not Completed
        </Typography>
        <Typography className={clsx(classes.muted, classes.confirmSubtitle)}>
          Your payment didn&apos;t go through, so your Virtual Coaching purchase
          was not completed. Please try again with the same or a different card.
        </Typography>
      </Box>
      {retryTo ? (
        <Box className={classes.centerAction}>
          <RouterLinkButton
            variant="contained"
            color="primary"
            size="large"
            to={retryTo}
          >
            Try Again
          </RouterLinkButton>
        </Box>
      ) : null}
    </Box>
  )
}

PurchaseFailed.propTypes = {
  retryTo: PropTypes.string,
}
